// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { API_HOST, AUTO_SAVE_TIME } from "../../../common/constant";
import axios from "axios";
import { callApi } from "../../../common/util/api";


export default function CEitor({
  postType,
  postId,
  placeholder,
  htmlContent,
  getHtmlContent,
  getTempHtmlContent,
  imageMap,
  videoMap,
  editorRef,
}) {

  const [edit, setEdit] = useState(null);

  const [postIdInit, setPostIdInit] = useState(false);
  const [typingYsno, setTypingYsno] = useState(false);
  const [timerMs, setTimerMs] = useState(new Date().getTime());
  const [CurrentMs, setCurrentMs] = useState(new Date().getTime() + AUTO_SAVE_TIME);

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const formData = new FormData();
          loader.file.then(async (file) => {
            formData.append("image", file);
            await axios({
              url: "/image",
              method: "post",
              baseURL: API_HOST,
              data: formData,
              withCredentials: true,
            })
              .then((response) => {
                const id = response?.data?.id ?? null;
                const fileName = response?.data?.fileName ?? null;
                if (id && fileName) {
                  imageMap.current.set(fileName, id);
                  resolve({ default: fileName });
                } else {
                  reject();
                }
              })
              .catch(() => null);
          });
        });
      }
    };
  }

  // video 다음 빈 paragraph 제거 + 임시 스타일 정리
  function cleanData(html) {
    if (!html) return '';
    let result = html;
    result = result.replace(/(<video\b[^>]*)\bstyle="([^"]*)"/gi, (m, before, style) => {
      const cleaned = style
        .replace(/\s*transition:[^;]+;?\s*/gi, ' ')
        .replace(/\s*opacity:\s*[\d.]+\s*;?\s*/gi, ' ')
        .trim()
        .replace(/\s+/g, ' ');
      return cleaned ? `${before}style="${cleaned}"` : before;
    });
    // 패턴: </video></p><p>&nbsp;</p>
    let prev;
    do {
      prev = result;
      result = result.replace(
        /(<\/video>\s*<\/p>)\s*<p[^>]*>(?:&nbsp;|\s)*(?:<br\s*\/?>)?(?:&nbsp;|\s)*<\/p>/gi,
        '$1'
      );
    } while (result !== prev);
    return result;
  }

  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  useEffect(() => {
    if (!postId) return;
    const fetchData = async () => {
      const firstType = postType;
      if (postType === 'temp' && firstType === postType) {
        if (!postIdInit) {
          setPostIdInit(true);
          const { data } = await callApi({
            method: "get",
            url: `/post/${postId}/content?postType=${postType}`,
          });
          getHtmlContent(data?.postContent ?? "");
          data?.images?.forEach(item => imageMap.current.set(item.fileName, item.id));
          data?.videos?.forEach(item => videoMap.current.set(item.fileName, item.id));
        }
      } else {
        const { data } = await callApi({
          method: "get",
          url: `/post/${postId}/content?postType=${postType}`,
        });
        getHtmlContent(data?.postContent ?? "");
        data?.images?.forEach(item => imageMap.current.set(item.fileName, item.id));
        data?.videos?.forEach(item => videoMap.current.set(item.fileName, item.id));
      }
    };
    fetchData();
  }, [postId]);

  useEffect(() => {
    const time = setInterval(() => {
      if (new Date().getTime() - timerMs >= 2000 && !typingYsno) {
        setTypingYsno(true);
      }
    }, 1000);
    return () => { clearInterval(time); };
  }, [typingYsno, timerMs]);

  useEffect(() => {}, [CurrentMs]);

  useEffect(() => {
    if (edit && typingYsno && CurrentMs <= new Date().getTime()) {
      setCurrentMs(CurrentMs + AUTO_SAVE_TIME);
      const data = cleanData(edit?.getData());
      getHtmlContent(data);
      getTempHtmlContent(data);
    }
  }, [edit, typingYsno, CurrentMs, getHtmlContent, getTempHtmlContent]);

  return (
    <CKEditor
      editor={Editor}
      config={{
        extraPlugins: [uploadPlugin],
        placeholder: '기록하고 싶은 이야기를 적어보세요.',
        videoUpload: {
          uploadUrl: `${API_HOST}/video`,
          onUploadSuccess: (id, fileName) => {
            videoMap.current.set(fileName, id);
          },
        },
      }}
      data={htmlContent}
      onReady={(editor) => {
        editor.model.document.selection.on('change', () => {
          requestAnimationFrame(() => {
            const domSelection = window.getSelection();
            if (!domSelection || domSelection.rangeCount === 0) return;
            const node = domSelection.focusNode;
            if (!node) return;
            const el = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
            el?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          });
        });
      }}
      onBlur={(_, editor) => {
        const data = cleanData(editor?.getData());
        getHtmlContent(data);
      }}
      onChange={(_, editor) => {
        if (edit == null && editor?.getData()) setEdit(editor);
        if (editorRef) editorRef.current = editor;
        setTimerMs(new Date().getTime());
        setTypingYsno(false);
      }}
    />
  );
};
